import React from "react";
import { Link } from "react-router-dom";
import { APP_URLS } from "../constants";

class ServiceDetail extends React.Component {
    render() {
        const { details } = this.props;
        return (
            <section className="seo-section-six">
                <div className="auto-container">
                    <div className="row clearfix">
                        <div className="content-column col-lg-6 col-md-12 col-sm-12">
                            <div className="inner-column">
                                <h2>{details.title}</h2>
                                <div className="text">
                                    <h3>
                                        <b>
                                            <i>{details.desc1}</i>
                                        </b>
                                    </h3>
                                    <br />
                                    <p style={{ textAlign: "justify" }}>
                                        {details.desc2}
                                    </p>
                                </div>
                                <ul className="list-style-two">
                                    <li>{details.list1}</li>
                                    <li>{details.list2}</li>
                                    <li>{details.list3}</li>
                                </ul>

                                <Link
                                    to={APP_URLS.PORTFOLIO}
                                    className="theme-btn btn-style-four"
                                >
                                    Portfolio
                                </Link>
                            </div>
                        </div>

                        <div className="image-column col-lg-6 col-md-12 col-sm-12">
                            <div className="inner-column clearfix">
                                <div
                                    className="image image-one wow fadeInRight"
                                    data-wow-delay="0ms"
                                    data-wow-duration="1500ms"
                                >
                                    <img
                                        style={{height:'400px', alignItems:'center'}}
                                        src={"images/"+details.image}
                                        alt=""
                                    />
                                </div>
                                <div
                                    className="image image-two wow fadeInRight"
                                    data-wow-delay="300ms"
                                    data-wow-duration="1500ms"
                                >
                                    <img
                                        src={"images/"+details.image2}
                                        alt=""
                                    />
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
        );
    }
}
export default ServiceDetail;
